import { getAuthAxiosBackend } from "../helpers/axios"

class VideoServices{

    constructor(){
    }

    get(id){
        return getAuthAxiosBackend().get( 'videos' + '/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('videos', {params: data})
    }

    add(video){
        return getAuthAxiosBackend().post('videos', video)
    }

    edit(id, video){
        video.append('_method', 'put')
        return getAuthAxiosBackend().post('videos' + '/' + id, video)
    }

    delete(id){
        return getAuthAxiosBackend().delete('videos' + '/' + id)
    }
}

export default new VideoServices()